import SidebarLayout from '../../components/SidebarLayout';
import SubjectsUpdateForm from '../../components/sections/MTSS/SubjectsUpdateForm';
import { useParams } from 'react-router-dom';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import { useContext, useEffect } from 'react';

export default function SubjectsUpdate() {
  const params = useParams();
  const id = params?.id;
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/update-subject');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<SubjectsUpdateForm params={id} />}
          heading={'Update Subject'}
        />
      </div>
    </AccessWrapper>
  );
}
